type SessionUser = {
  uid: string;
  emailVerified: boolean;
  getIdToken(forceRefresh: boolean): Promise<string>;
};

/** Load migrated access claims before the first Firestore requests of a restored
 * session. Keep the cached session usable when the network is unavailable. */
export async function sessionUid(user: SessionUser | null): Promise<string | null> {
  if (!user?.emailVerified) return null;
  try {
    await user.getIdToken(true);
  } catch {
    // A network failure must not sign out an otherwise valid cached session.
  }
  return user.uid;
}
